import { Any } from 'cosmjs-types/google/protobuf/any'

import { encodeString } from './proto'

export interface UnjailParams {
  validatorAddress: string
}

export function buildUnjailMsg(params: UnjailParams): Any {
  const value = Uint8Array.from([...encodeString(1, params.validatorAddress)])

  return Any.fromPartial({
    typeUrl: '/cosmos.slashing.v1beta1.MsgUnjail',
    value,
  })
}
